/**
 * Home page "Watch live" panel (sections/stream.liquid).
 *
 * A "not live" card shows by default. When the panel comes near the screen,
 * Twitch's embed script loads the player behind the card; Twitch tells us
 * when the channel is live (ONLINE) or not (OFFLINE), and the card hides or
 * shows to match. If Twitch can't be reached, the card simply stays.
 */
(() => {
  const box = document.querySelector('[data-stream-player]');
  if (!box) return;

  const TWITCH_SCRIPT = 'https://player.twitch.tv/js/embed/v1.js';

  const loadTwitch = () =>
    new Promise((resolve, reject) => {
      if (window.Twitch && window.Twitch.Player) return resolve(window.Twitch);
      const script = document.createElement('script');
      script.src = TWITCH_SCRIPT;
      script.async = true;
      script.onload = () => resolve(window.Twitch);
      script.onerror = reject;
      document.head.append(script);
    });

  const start = async () => {
    let Twitch;
    try {
      Twitch = await loadTwitch();
    } catch (e) {
      return; // The card stays.
    }
    if (!Twitch || !Twitch.Player) return;

    const player = new Twitch.Player(box.querySelector('[data-stream-embed]'), {
      channel: box.dataset.channel,
      parent: [box.dataset.parent || location.hostname],
      width: '100%',
      height: '100%',
      autoplay: false,
      muted: true,
    });
    const live = (isLive) => {
      box.dataset.state = isLive ? 'live' : 'offline';
    };
    player.addEventListener(Twitch.Player.ONLINE, () => live(true));
    player.addEventListener(Twitch.Player.OFFLINE, () => live(false));
    player.addEventListener(Twitch.Player.PLAYING, () => live(true));
  };

  if ('IntersectionObserver' in window) {
    const watch = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        watch.disconnect();
        start();
      },
      { rootMargin: '400px' }
    );
    watch.observe(box);
  } else {
    start();
  }
})();
